import { Card, Loader, Stack, Text } from "@mantine/core";

import { useSession } from "@/hooks/@custom/useSession";
import { useGetQueueNextDateByCompanyQuery } from "@/store/apis/nextcargo";

type QueueInfoProps = unknown;

export function QueueInfo(_props: QueueInfoProps) {
  const { driver } = useSession();
  const driverCompanyId = driver?.company.id;

  const { data, isLoading } = useGetQueueNextDateByCompanyQuery({ id: driverCompanyId! }, { skip: !driverCompanyId });

  return (
    <Card className="border-primary-200! bg-primary-50!" ta="center" withBorder>
      <Stack gap={0}>
        {isLoading && (
          <div className="grid place-content-center">
            <Loader />
          </div>
        )}

        {!isLoading && (
          <>
            <Text size="lg">Neste momento, temos:</Text>
            <Stack align="center" justify="center" gap="xs">
              <Text fw="bolder" size="3xl" c="primary.7">
                {data?.totals}
              </Text>

              <Text size="lg">Veículos em espera</Text>
            </Stack>
          </>
        )}
      </Stack>
    </Card>
  );
}
